<template>
    <div class="form form-check">
        <input
            v-bind:id="id"
            v-bind:key="id"
            v-gtm:@click
            v-gtm:label="gtmLabel ?? ''"
            class="checkbox"
            type="checkbox"
            v-bind:indeterminate="indeterminate"
            v-bind:checked="checked"
            v-bind:disabled="disabled"
            v-on:input="onclick(($event.target as HTMLInputElement).checked)"
        >
        <label class="checkbox_label" v-bind:for="id">
            <slot name="label" />
        </label>
    </div>
</template>

<script lang="ts" setup>
    import type { PropType } from 'vue';

    defineProps({
        id: {
            type: String,
            required: true,
        },
        checked: {
            type: Boolean,
            default: false,
        },
        indeterminate: {
            type: Boolean,
            default: false,
        },
        onclick: {
            type: Function as PropType<(change: boolean) => void>,
            default: () => false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        gtmLabel: {
            type: String,
            default: '',
        },
    });

</script>
